import { ComponentRef, forwardRef } from "react";
import Image, { ImageProps } from "next/image";
import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";
import { mediaRefAlt, mediaRefUrl } from "@/app/features/shared/__to_be_integrated/types/general/media/media-helper";
import clsx from "clsx";
import sharedStyles from "../media-view-shared.module.css";

type ImageViewProps = Omit<ImageProps, 'src' | 'alt'> & {
    src: MediaRef,
    alt?: string,
    zoomOnHover?: boolean,
}

const ImageView = forwardRef<
    ComponentRef<typeof Image>,
    ImageViewProps
>(
    ({ src, alt, zoomOnHover, ...props }, ref) => {
        const imageUrl = mediaRefUrl(src);
        const mediaAlt = mediaRefAlt(src);

        // Provide sensible defaults to reduce payload size
        const effectiveSizes = props.sizes ?? (props.fill ? '(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw' : undefined);
        const effectiveQuality = props.quality ?? 75;
        const objectFit = props.style?.objectFit;

        return (
            <Image
                {...props}
                className={clsx(
                    "media-view-image-inner transition-transform duration-300 ease-in-out",
                    props.fill && "size-full",
                    props.fill && !objectFit && "object-cover",
                    objectFit === 'contain' && "object-contain",
                    objectFit === 'cover' && "object-cover",
                    props.className,
                    zoomOnHover && sharedStyles.imageZoomOnHover,
                )}
                ref={ref}
                src={imageUrl}
                alt={alt ?? mediaAlt ?? ''}
                sizes={effectiveSizes}
                quality={effectiveQuality}
            />
        )
    }
)

ImageView.displayName = "ImageView";
export default ImageView;
